import React from "react";
import Masterbar from "./Masterbar";
import { ADMIN_DATA_BAR } from "constants/ui-constants";

export default () => <Masterbar {...ADMIN_DATA_BAR} />;
